// src/features/auth/authAPI.js
import axiosInstance from '../../api/axiosInstance';

export const loginAPI = async (credentials) => {
    const response = await axiosInstance.post('/users/login', credentials);
    return response.data;
};

export const otpVerifyService = async (credentials) => {
    const response = await axiosInstance.post('/users/otp-verify', credentials);
    return response.data;
};
export const logoutService = async () => {
    const response = await axiosInstance.get('/users/logout');
    return response.data;
};


